import React from "react";
import * as S from "./styles";
export var Refine = function Refine(e) {
  return React.createElement(S.SVG, Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15 14",
    width: "15",
    height: "14",
    "aria-hidden": "true"
  }, e), React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(0 1)"
  }, React.createElement("path", {
    fill: "#1E824C",
    d: "M0 1H15V3H0z"
  }), React.createElement("path", {
    fill: "#1E824C",
    d: "M0 9H15V11H0z",
    transform: "matrix(-1 0 0 1 15 0)"
  }), React.createElement("circle", {
    cx: "11",
    cy: "2",
    r: "2",
    fill: "#EDF5F1",
    stroke: "#1E824C",
    strokeLinejoin: "round",
    strokeWidth: "1.5"
  }), React.createElement("circle", {
    cx: "4",
    cy: "10",
    r: "2",
    fill: "#EDF5F1",
    stroke: "#1E824C",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    transform: "matrix(-1 0 0 1 8 0)"
  })));
};